var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-container"},[_c('v-btn',{attrs:{"color":"success"},on:{"click":_vm.refresh}},[_vm._v(" "+_vm._s(_vm.translate("demo.refreshButton"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }